/**
 * Convert flat ticket fields to structured EnvironmentInfo for display.
 * Used by dashboard components to reconstruct environment from ticket data.
 */
export function ticketFieldsToEnvironment(ticket) {
    return {
        browser: {
            name: ticket.browserName ?? 'Unknown',
            version: ticket.browserVersion ?? '',
        },
        os: ticket.os ?? 'Unknown',
        viewport: {
            width: ticket.viewportWidth ?? 0,
            height: ticket.viewportHeight ?? 0,
        },
        screen: {
            width: ticket.screenWidth ?? 0,
            height: ticket.screenHeight ?? 0,
        },
        devicePixelRatio: ticket.devicePixelRatio ?? 1,
    };
}
//# sourceMappingURL=tickets.js.map